import { memo, useState } from 'react';
import { useRouter } from 'next/router';

import { Box, Text } from '@zillow/constellation-10';

import { useGetListingDetails } from '../../../hooks/queries/properties';

import PhotoGallery from '../../PostingPath/MediaContent/PhotoUploadFormField/components/PhotoGallery';
import PhotoUpload from '../../PostingPath/MediaContent/PhotoUploadFormField/components/PhotoUpload';

type Props = {
  floorPlanIndex: number;
};

const FloorPlanUploadFormField = ({ floorPlanIndex }: Props) => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;

  const { data: listingDetails } = useGetListingDetails(listingAlias);

  const [uploadingCount, setUploadingCount] = useState(0);

  const isFeed = listingDetails?.isFeed ?? false;
  const floorPlan = listingDetails?.floorPlans?.[floorPlanIndex];
  const floorPlanPhotos = floorPlan?.floorPlanPhotos || [];

  if (!floorPlanPhotos.length && isFeed) {
    return (
      <Box data-testid="FloorPlanUploadFormField" css={{ width: '100%' }}>
        <Text css={{ marginTop: '200', flex: '1 0 fit-content' }}>No photos available</Text>
      </Box>
    );
  }

  return (
    <Box data-testid="FloorPlanUploadFormField" css={{ width: '100%' }}>
      {floorPlanPhotos.length > 0 || uploadingCount > 0 ? (
        <PhotoGallery
          photoContext={{ type: 'floorPlan', floorPlanId: floorPlan?.id || '', floorPlanIndex }}
          uploadingCount={uploadingCount}
          setUploadingCount={setUploadingCount}
          isUploadAllowed={!isFeed}
        />
      ) : (
        <>
          {!isFeed && (
            <PhotoUpload
              photoContext={{ type: 'floorPlan', floorPlanId: floorPlan?.id || '', floorPlanIndex }}
              setUploadingCount={setUploadingCount}
              uploadingCount={uploadingCount}
            />
          )}
        </>
      )}
    </Box>
  );
};

export default memo(FloorPlanUploadFormField);
